import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import Upload from "../../Upload";

import { WizardStep } from "../Wizard";

function Attachment({ formBag, modeSaveOrUpdate, isReadOnly }) {
  const intl = useIntl();
  const [supportedExtensions] = useSelector(({ theme }) => {
    return [theme.DocumentType?.item?.Items?.map((item) => item.Value)];
  });

  const { values, errors, setFieldValue } = formBag;

  return (
    <WizardStep name="Attachment">
      <div className="details-container">
        <div className="kpi-form-attachments">
          <Upload
            name="Attachments"
            label={intl.formatMessage({ id: "kpi.drop-file" })}
            error={errors.Attachments}
            onChange={(files) => setFieldValue("Attachments", files)}
            onDelete={(files) => setFieldValue("Attachments", files)}
            attachments={values.Attachments}
            disabled={isReadOnly}
            accept={{
              "image/*": supportedExtensions.map((item) => `.${item}`),
              "audio/*": supportedExtensions.map((item) => `.${item}`),
              "video/*": supportedExtensions.map((item) => `.${item}`),
              "text/*": supportedExtensions.map((item) => `.${item}`),
              "font/*": supportedExtensions.map((item) => `.${item}`),
              "application/*": supportedExtensions.map((item) => `.${item}`),
            }}
            multiple
          />
        </div>
      </div>
    </WizardStep>
  );
}

export default Attachment;
